<script>
import Modal from '@/components/atoms/Modal'
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import FormValidation from '@/components/atoms/FormValidation'
import ButtonLoader from '@/components/atoms/ButtonLoader'
export default {
    name: 'ModalForgotPassword',
    components: { ButtonLoader, FormValidation, InputLine, Modal },
    data() {
        return {
            email: null,
            disabled: true,
            loading: false,
        }
    },
    methods: {
        open() {
            this.email = null
            this.$refs.ModalForgotPassword.openModal()
        },
        close() {
            this.email = null
            this.$refs.ModalForgotPassword.closeModal()
        },
        submit() {
            this.$refs.form.formSubmit()
        },
        sendEmail() {
            this.loading = true
            this.$user
                .sendResetEmail(this.email)
                .then(() => {
                    this.close()
                })
                .finally(() => {
                    this.loading = false
                })
        },
        disableForm(val) {
            this.disabled = val
        },
    },
}
</script>

<template lang="pug">
.modal-forgot-password
    .text-center
        button.btn.btn-link.link-dark.font-size-sm(@click="open") {{$t('login.forgot_psw')}}
    modal(ref="ModalForgotPassword" sm :closable="false")
        template(v-slot:header)
            .modal-header-text {{ $t('login.forgot_psw') }}
        template(v-slot:body)
            form-validation(ref="form" @submit="sendEmail" @disable="disableForm")
                input-line(v-model="email" type="email" validate="email" :placeholder="$t('labels.placeholder.email')")
        template(v-slot:footer)
            button.btn.btn-secondary(@click="close") {{$t('base.cancel')}}
            button-loader.btn.btn-primary(@click="submit" :disabled="disabled" :loading="loading" inline) {{$t('login.set_new_psw')}}

</template>
